module.exports = __webpack_public_path__ + "static/img/img_6.9e560a73.jpg";